import { render } from "./FormLayout.vue?vue&type=template&id=06d5ddf8&scoped=true"
import script from "./FormLayout.vue?vue&type=script&lang=js"
export * from "./FormLayout.vue?vue&type=script&lang=js"

import "./FormLayout.vue?vue&type=style&index=0&id=06d5ddf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d5ddf8"]])

export default __exports__